import { createFileRoute } from "@tanstack/react-router";
import { LegalPage, legalHead } from "@/pages/LegalPage";
import { persondataStrings } from "@/i18n/content/legal";

export const Route = createFileRoute("/en/datapolicy")({
  head: () => legalHead("persondata", "en", persondataStrings.en.meta),
  component: () => <LegalPage {...persondataStrings.en} />,
});
